<template>
    <div class="Qualification-Certificates">
        <el-table :data="tableData" style="width: 100%;margin-top: 0.2rem" border size="mini" :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem'
        }" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
            <el-table-column prop="" label="序号" width="50" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="info.证书名称" label="证书名称" width="" align="center">
                <!-- <template slot-scope="scope">
                    {{ scope.row.info.证书名称 }}
                </template> -->
            </el-table-column>
            <el-table-column prop="info.资质类别及等级/产品名称" label="资质类别及等级/产品名称" width="" align="center">
            </el-table-column>
            <el-table-column prop="info.证书编号" label="证书编号" width="" align="center">
            </el-table-column>
            <el-table-column prop="info.发证机构" label="发证机构" width="" align="center">
            </el-table-column>
            <el-table-column prop="info.发证日期" label="发证日期" width="" align="center">
            </el-table-column>
            <el-table-column prop="info.有效期至" label="有效期至" width="" align="center">
            </el-table-column>
            <el-table-column prop="info.证书状态" label="证书状态" width="" align="center">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'QualificationCertificates',
    data() {
        return {

        }
    },
    props: {
        tableData: {
            type: [Array]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/QualificationCertificates.vue